module.exports = __webpack_public_path__ + "img/apps.560d813b.png";